import React from "react";
import LineOrange from "../../../common/LineOrange/LineOrange";
import styles from "../style.module.css";
export const TransactionCredit = () => {
  return (
    <>
      <div className="container">
        <div className="text-center mb-5 mt-5">
          {/* <p style={{ fontSize: "28px", fontWeight: "800" }}>همراه‌تریدر</p> */}
          <h3>اعتبار معاملاتی</h3>
          <LineOrange />
          <div className="">
            <img
              src={
                "/asset/images/backgroundImage/Leverage-in-Real-Estate-Investing.png"
              } 
              className={styles.transaction_img}
              alt=""
            />
            <p className="text-right mt-3">
              در کارگزاری مبین سرمایه با هزینه مالی کمتر، اعتبار بیشتر دریافت
              کنید. شما می‌توانید معادل 10 درصد میانگین گردش سه ماهه حساب خود
              اعتبار بگیرید. همچنین متناسب با گردش حساب خود، قادر خواهید بود
              هزینه مالی را به صفر برسانید. در این وضعیت نه به صورت نقدی و نه در
              قالب امتیاز باشگاه، هیچ هزینه‌ای پرداخت نخواهید کرد. <br />
              حتی اگر گردش حساب شما در یک کارگزاری دیگر باشد، می‌توانید با ارائه
              گردش حساب سه‌ماهه خود، از اعتبار معاملاتی استفاده کنید. <br />
              همچنین برای رفاه حال سرمایه‌گذاران و سهولت هرچه بیشتر استفاده از
              ابزارهای مالی، ثبت نام غیرحضوری و امکان استفاده از تغییر ناظر
              سیستمی از داخل سامانه اسمارت در نظر گرفته شده است. <br />
              برای ارتباط با واحد اعتبارات با تلفن
              <a className={styles.Tel} href="tel:1579">
                {" "}
                1579{" "}
              </a>
              داخلی 540 الی 546 تماس حاصل فرمایید.
            </p>
          </div>
        <div className={styles.btnWhy}>
          <a href="https://reg.mobinsb.ir/Bourse/CustomerCreditRequest/index" target="_blank" rel="noreferrer">
            از اینجا شروع کنید 
          </a>
        </div>
        </div>
      </div>
    </>
  );
};
